import { Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Radio, RadioGroup, Typography } from '@material-ui/core';
import cx from 'classnames';
import * as React from 'react';
import { translate } from '../../../../../common/intl';
import { statusClassMapping } from '../../../../components/common/kendo/helpers';
import { DialogHandler } from '../../../../hooks/useDialog';
import { styles } from '../treelist/column.templates/styles';
import { AlternatePartDetails } from '../treelist/interface';

export interface ReplacementDialogProps {
  onConfirmReplacement?: (selectedAlternatePart: AlternatePartDetails) => void
  replacementDialog: DialogHandler
  availableAlternateParts: AlternatePartDetails[]
}

const PartReplacementDialog: React.FunctionComponent<ReplacementDialogProps>
  = ({
    onConfirmReplacement,
    replacementDialog,
    availableAlternateParts = [],
  }) => {
    const classes = styles();
    const [selectedPartId, setSelectedPartId] = React.useState<string>('');

    const selectedPart = availableAlternateParts.find(
      part => part.id === selectedPartId,
    );

    return (
      <Dialog
        disableEscapeKeyDown={true}
        disableBackdropClick={true}
        open={replacementDialog.isOpen}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>{translate('allocation.select.alternate.part.dialog.title')}</DialogTitle>
        <DialogContent dividers>
          <RadioGroup
            value={selectedPartId}
            onChange={(e) => setSelectedPartId(e.target.value)}
          >
            {availableAlternateParts.map((part) => (
              <Box className={classes.alternatePartBox}
                key={part.id}
              >
                <FormControlLabel
                  value={part.id}
                  control={<Radio />}
                  label={
                    <Box className={classes.labelBox}>
                      <Box className={classes.labelText}>
                        <Typography variant="subtitle1">
                          {part.docId} • Rev {part.displayRevision}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                          {part.name}
                        </Typography>
                      </Box>
                      <Chip
                        size="small"
                        className={cx(
                          classes.chip,
                          classes[statusClassMapping[part.displayStatus]],
                        )}
                        label={part.displayStatus}
                      />
                    </Box>
                  }
                />
              </Box>
            ))}
          </RadioGroup>
        </DialogContent>
        <DialogActions>
          <Button onClick={replacementDialog.close}>
            {translate('common.cancel')}
          </Button>

          <Button
            color="primary"
            variant="contained"
            disabled={!selectedPart}
            onClick={() => selectedPart && onConfirmReplacement?.(selectedPart)}
          >
            {translate('allocation.select.alternate.part.dialog.confirm')}
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

export default PartReplacementDialog;
